import { put } from 'redux-saga/effects';

import { analyticsEventAction } from '@pressreader/analytics-core';
import { takeEvery } from '@pressreader/appstore';

import { openFontsMenuAction } from '../actions';

function* onOpenFontsMenu() {
    yield put(analyticsEventAction({ category: 'Menus', action: 'IssueContextMenu', label: 'fonts' }));
}

export function* saga() {
    yield takeEvery(openFontsMenuAction, onOpenFontsMenu);
}
